import { css } from 'css-literal-loader/styled';
import React from 'react';
import ReactDOM from 'react-dom';

export const breakpointValues = require('./Responsive-breakpointValues.module.scss');

const matchers = new Map();

// sometimes the order isn't correct so we just hardcode the list
const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl'];
const mobileBreak = 'md';

const getMinQuery = breakpoint =>
  `(min-width: ${breakpointValues[breakpoint]})`;

const getMaxQuery = breakpoint => {
  const next = Math.min(
    breakpoints.indexOf(breakpoint) + 1,
    breakpoints.length - 1,
  );
  const px = parseInt(breakpointValues[breakpoints[next]], 10);
  return `(max-width: ${px - 0.2}px)`;
};

class Responsive extends React.Component {
  state = { query: '' };

  static getDerivedStateFromProps(
    { mobileOnly, desktopOnly, media, ...rest },
    prevState,
  ) {
    const props = rest;
    let query = media || '';
    if (mobileOnly) {
      query = getMaxQuery(mobileBreak);
    } else if (desktopOnly) {
      query = getMinQuery(mobileBreak);
    } else {
      for (const key of breakpoints) {
        if (props[`${key}Up`]) {
          delete props[`${key}Up`];
          query = getMinQuery(key);
        }
        if (props[`${key}Down`]) {
          delete props[`${key}Down`];
          query += (query ? ' and ' : '') + getMaxQuery(key);
        }
      }
    }

    return { query, lastQuery: prevState.query };
  }

  componentWillUnmount() {
    this.unmounted = true;
    if (this.unlisten) {
      this.unlisten();
      this.unlisten = null;
    }
  }

  handleChange = () => {
    if (this.unmounted) return;
    ReactDOM.unstable_batchedUpdates(() => {
      if (this.unmounted) return;
      this.forceUpdate();
    });
  };

  matches() {
    const { query, lastQuery } = this.state;

    if (query !== lastQuery && this.unlisten) {
      this.unlisten();
      this.unlisten = null;
    }

    let mql = matchers.get(query);
    if (!mql) {
      matchers.set(query, (mql = window.matchMedia(query)));
    }

    if (!this.unlisten) {
      mql.addListener(this.handleChange);
      this.unlisten = () => mql.removeListener(this.handleChange);
    }

    return mql.matches;
  }

  render() {
    const { children } = this.props;
    const matches = this.matches();

    if (typeof children === 'function') return children(matches);
    return matches ? children : null;
  }
}

export default Responsive;
